import * as React from "react";
import { Container } from "../../Container";
import { Confirmation } from "../Dialogs/Confirmation";
import { DeleteObjectsStore, DeleteObjectsActions } from "../../flux/DeleteObjects";
import { Polyglot } from "../../../polyglot";
import { EntityType } from "../../../models";
import { Command } from "../../../Command";

export interface DeleteItemsProps
{
    deleteObjectsStore: DeleteObjectsStore;
    deleteObjectsCommand: Command;
}

interface WidgetProps
{
    polyglot: Polyglot;
    entityType: EntityType;
    title: string;
}
type Props = DeleteItemsProps & WidgetProps;
export class DeleteConfirmationWidget extends React.Component<Props, any>
{
    private readonly deleteObjectsActions = new DeleteObjectsActions();
    render()
    {
        const { polyglot, entityType, deleteObjectsStore, title } = this.props;
        return (
            <Container store={deleteObjectsStore}>
                <Confirmation
                    title={title}
                    okTitle={polyglot.t('button.delete')}
                    cancelTitle={polyglot.t('button.cancel')}
                    cancel={() => this.deleteObjectsActions.hideConfirmation(entityType) }
                    ok={this.props.deleteObjectsCommand.execute}>
                        { this.props.children }
                </Confirmation>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/DeleteConfirmationWidget/DeleteConfirmationWidget.tsx